import { ChevronDown } from 'lucide-react';

import { Flex, Space, VFlex } from '@/components/base';
import Button from '@/components/Button/Button';
import { FEEDBACK_BODY_TYPE } from '@/types/feedbackConst';

import { getFeedbackFieldListBySourceType } from '../../configs';
import { useFeedbackDetailProperty } from '../../hooks/useFeedbackDetailProperty';

const FeedbackDetailPropertyArea = (props: {
  detailProps: {
    feedbackAlias: string;
    detail: FeedbackT;
  };
  static?: boolean;
  showFull: boolean;
  setShowFull: (v: boolean) => void;
}) => {
  const { detail } = props.detailProps;
  const { showFull, setShowFull } = props;

  const getFieldComponent = useFeedbackDetailProperty({
    feedback: detail,
    isStatic: props.static ?? false,
    showFull,
    setShowFull,
  });

  const fieldList = getFeedbackFieldListBySourceType(
    detail.source.type,
    detail.body_type || FEEDBACK_BODY_TYPE.PLAIN_TEXT,
    showFull,
  );

  return (
    <VFlex g={1}>
      {fieldList.map((field) => getFieldComponent(field))}
      <Space h="6px" />
      <Flex className="-mx-2.5">
        <ShowMoreButton
          toggle={() => {
            setShowFull(!showFull);
          }}
          showFull={showFull}
        />
      </Flex>
    </VFlex>
  );
};

const ShowMoreButton = (props: { toggle: () => void; showFull: boolean }) => {
  return (
    <Button
      variant="ghost"
      sizeType="s"
      leftIcon={
        <ChevronDown
          size={12}
          style={{
            transition: 'transform 0.2s',
            transform: props.showFull ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
        />
      }
      onClick={props.toggle}
    >
      {props.showFull ? 'Show less' : 'Show more'}
    </Button>
  );
};

export default FeedbackDetailPropertyArea;
